__turbopack_context__.v({
  "active": "index-module__P0Xu9a__active",
  "bottom": "index-module__P0Xu9a__bottom",
  "bottomWithFiles": "index-module__P0Xu9a__bottomWithFiles",
  "inner": "index-module__P0Xu9a__inner",
  "smallUploadButton": "index-module__P0Xu9a__smallUploadButton",
  "textarea": "index-module__P0Xu9a__textarea",
  "uploadButton": "index-module__P0Xu9a__uploadButton",
  "uploadButtonInner": "index-module__P0Xu9a__uploadButtonInner",
  "wrapper": "index-module__P0Xu9a__wrapper",
});
